import { prepareCommonRailData } from "~/features/configurator/Rail/api/sendRailCommon";
import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { getCsrfValue } from "~/common/utils/ApiHelper";
import { type PriceInfo } from "~/domains/pricing/api/PriceInfo";

export function sendRailAddToCart(linearState: LinearConfiguratorState, priceInfo: PriceInfo | null): Promise<string> {
  const data = prepareCommonRailData(linearState, priceInfo);

  return fetch(window.location.href.substring(0, window.location.href.lastIndexOf("/")) + "/addToCart2", {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      return result.json();
    } else {
      console.error(`Error sending rails update: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
